module.exports = __webpack_public_path__ + "img/arrow-left.b6334e3c.svg";